// extracted by mini-css-extract-plugin
export var container = "CardHover-module--container--2c150";
export var hover = "CardHover-module--hover--63970";
export var hoverContent = "CardHover-module--hoverContent--ca7c4";
export var hoverContentLeft = "CardHover-module--hoverContentLeft--69c45";
export var hoverContentUp = "CardHover-module--hoverContentUp--c524d";
export var hoverDoubleFaced = "CardHover-module--hoverDoubleFaced--3a438";
export var hoverImage = "CardHover-module--hoverImage--5d624";
export var modal = "CardHover-module--modal--33f64";
export var modalDoubleFaced = "CardHover-module--modalDoubleFaced--b1da0";
export var modalImage = "CardHover-module--modalImage--23d58";
export var unstyled = "CardHover-module--unstyled--efc48";